export default __webpack_public_path__ + "components/forecast-table-elevation/static/mountain-outline-cb107ed13ed218f718564984df2040b6.png";